module.exports = __webpack_public_path__ + "img/1920x300.355f387f.jpg";